// extracted by mini-css-extract-plugin
export default {"productGrid":"x0-z","centerLink":"y0-z","productSection":"z0-z","item":"A0-z","ctaButton":"B0-z"};